import AttachmentWellViewState from '../../schema/AttachmentWellViewState';
import { CreateAttachmentsProperties } from '../../types/CreateAttachmentsProperties';
import { AttachmentFile, AttachmentFileType } from 'owa-attachment-file-types';
import { AttachmentConstants } from 'owa-attachment-model-store/lib/utils/attachmentConstants';
import { lazyCreateAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import { lazyCreateAttachmentFileFromExistingMailboxAttachment } from 'owa-attachment-well-data';
import { ClientItemId } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default async function createAttachmentsFromRecentAttachments(
    itemId: ClientItemId,
    attachmentWell: AttachmentWellViewState,
    recentAttachments: AttachmentType[],
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void,
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void
) {
    const createAttachmentFileFromAttachmentType = await lazyCreateAttachmentFileFromExistingMailboxAttachment.import();
    const attachmentFiles: AttachmentFile[] = recentAttachments
        .filter(a => !isClassicInlineAttachment(a))
        .map(createAttachmentFileFromAttachmentType);
    const cloudFiles = attachmentFiles.filter(a => a.fileType === AttachmentFileType.Cloud);
    const attachmentItemFiles = attachmentFiles.filter(
        a => a.fileType === AttachmentFileType.AttachmentItem
    );
    attachmentItemFiles.length > 0 &&
        lazyCreateAttachment(
            attachmentWell,
            itemId,
            attachmentItemFiles,
            infoBarAddHandler,
            infoBarRemoveHandler,
            false /* isInline */,
            false /* shouldShare */
        );

    cloudFiles.length > 0 &&
        lazyCreateAttachment(
            attachmentWell,
            itemId,
            cloudFiles,
            infoBarAddHandler,
            infoBarRemoveHandler,
            false /* isInline */,
            true /* shouldShare */
        );
}

function isClassicInlineAttachment(attachmentType: AttachmentType) {
    return (
        attachmentType.__type !== AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE &&
        attachmentType.IsInline
    );
}

function lazyCreateAttachment(
    attachmentWell: AttachmentWellViewState,
    itemId: ClientItemId,
    attachments: AttachmentFile[],
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void,
    infoBarRemoveHandler: (infoBarMessageIds: string[]) => void,
    isInline: boolean,
    shouldShare: boolean
) {
    const baseProperties = {
        isInline,
        isHiddenInline: false,
    };
    const properties: CreateAttachmentsProperties = shouldShare
        ? {
              ...baseProperties,
              shouldShare: true,
          }
        : { ...baseProperties, shouldShare: false };

    lazyCreateAttachmentsViaQueueManager.import().then(createAttachmentsViaQueueManager => {
        createAttachmentsViaQueueManager(
            attachmentWell,
            itemId,
            attachments,
            infoBarAddHandler,
            infoBarRemoveHandler,
            properties
        );
    });
}
